import React from "react";

export const PointerDrag = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 19 19"
    >
      <path
        d="M14.932 9.686h.003l.002 3.127c0 .13-.007.258-.02.385a3.745 3.745 0 01-3.725 3.383H8.178c-1.7 0-2.857-1.438-3.329-2.156-.157-.24-.238-.4-.238-.4L2.507 9.77a1.16 1.16 0 01.524-1.548c.474-.24.907-.117 1.284.178.028.022.055.045.083.07.87.756 1.417 2.398 1.417 2.398V7.594a1.13 1.13 0 011.13-1.13c.624 0 1.13.487 1.13 1.13h.039c0-.82.488-1.328 1.097-1.345a.83.83 0 01.032 0 1.173 1.173 0 01.548.136c.363.19.62.564.62.993v.908a1.129 1.129 0 011.85-.873c.25.208.41.522.41.873v1.243a1.13 1.13 0 012.261 0v.157z"
        clipRule="evenodd"
      />
    </svg>
  );
};
